import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
  "Visitor registration & management",
  "Phone call handling & routing",
  "Email & communication management",
  "Guest reception & hospitality",
  "Meeting room coordination",
  "Courier & mail management",
  "Access card issuance",
  "Vendor coordination",
  "Employee assistance",
  "Facility information desk",
  "Administrative support",
  "Professional representation",
 
];

const steps = [
  {
    number: "01",
    title: "Requirement Understanding",
    desc: "Assess your reception needs, visitor volume, and service expectations.",
  },
  {
    number: "02",
    title: "Executive Selection",
    desc: "Deploy trained front office professionals matching your requirements.",
  },
  {
    number: "03",
    title: "Training & Onboarding",
    desc: "Provide organization-specific training on protocols and systems.",
  },
  {
    number: "04",
    title: "Ongoing Management",
    desc: "Supervise performance, gather feedback, and ensure service excellence",
  },
];

const FrontOfficeServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Front Office Service Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default FrontOfficeServices;
